import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'
import Dotdotdot from 'react-dotdotdot'

import { SADBReview } from '@f-fertighaus/applications/SalesAgentDashboard/interfaces/SADBReview'
import { ReviewRating } from '@f-fertighaus/components/ReviewRating/ReviewRating'

export const Review = ({
  title,
  text,
  reviewer_first_name,
  reviewer_last_name,
  rating,
  rated_at
}: SADBReview) => {
  return (
    <ReviewWrapper>
      <Dotdotdot clamp={3}>
        <Typography
          variant='bodyTitle'
          marginBottom={1}
          component='p'
          sx={{ lineHeight: '1' }}>
          {title}
        </Typography>
      </Dotdotdot>
      <MainTextWrapper variant='body2'>
        <Dotdotdot clamp={6}>
          <Typography variant='body2'>{text}</Typography>
        </Dotdotdot>
      </MainTextWrapper>
      <div>
        <ReviewRating rating={rating} variant='monocolor' />
        <Typography variant='body2' marginTop={1}>
          <strong>{rated_at}</strong>
          <Name>
            {(reviewer_first_name || reviewer_last_name) &&
              `${reviewer_first_name} ${reviewer_last_name?.[0]}.`}
          </Name>
        </Typography>
      </div>
    </ReviewWrapper>
  )
}

const ReviewWrapper = styled.div`
  background: ${({ theme }) => theme.palette.glass[500]};
  min-width: 240px;
  max-height: 290px;
  padding: 24px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-width: 200px;
  }
`

const MainTextWrapper = styled.div`
  flex: 1;
  margin-bottom: 16px;
`

const Name = styled.span`
  margin-left: 8px;
  color: ${({ theme }) => theme.palette.stone[300]};
`
